<!-- if screen width <= 1700 (mobile) will only show as one table, it did not separate to 2 grid for 1 row-->

<div *ngIf="screenWidth <= 1700" nz-row nzJustify="end" style="overflow-x: auto">
  <div nz-col>
    @if (showTotalPaid) {
    <table>
      <tbody>
        <tr>
          <td>
            <span class="tax-amount left-align">
              <strong>Total Paid</strong>
            </span>
          </td>
          <td class="amount-label">
            <span class="tax-amount">
              {{ getTotalPaid() | protectedCurrency:protected:' ' }}
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <span class="tax-amount left-align">
              <strong>O/T</strong>
            </span>
          </td>
          <td class="amount-label">
            <span class="tax-amount">
              {{ outstandingAmount | protectedCurrency:protected:' ' }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
    }

    @if (!showTotalPaid) {
    <table>
      <tbody>
        @if (showDeposit) {
        <tr>
          <td>
            <span class="tax-amount left-align">
              <strong>Deposit Payment Amount</strong>
            </span>
          </td>
          <td class="amount-label">
            <div class="tax-amount deposit-box clickable-box" (click)="deposit.openListing()">
              {{ depositAmount | protectedCurrency:protected: ' '}}
            </div>
          </td>
        </tr>
        }

        @if (eInvoiceSrv.isEnabled) {
        <tr>
          <td>
            <span class="tax-amount left-align">
              <strong>Amount Exempted from Tax</strong>
            </span>
          </td>
          <td class="amount-label">
            <span class="tax-amount">
              {{ amountExemptedFromTax | protectedCurrency:protected:' ' }}
            </span>
          </td>
        </tr>
        
        <tr>
          <td>
            <span class="tax-amount left-align">
              <strong>Exempted Tax Amount</strong>
            </span>
          </td>
          <td class="amount-label">
            <span class="tax-amount">
              {{ taxExemptionTotalAmount | protectedCurrency:protected:' ' }}
            </span>
          </td>
        </tr>
        }
        <tr>
          <td>
            <strong class="tax-amount left-align">Subtotal</strong>
          </td>
          <td class="amount-label">
            <span class="tax-amount">
              {{ getSubtotal() | protectedCurrency:protected:' ' }}
            </span>
          </td>
        </tr>

        @if (showDisc) {
        <tr>
          <td>
            <strong class="tax-amount left-align">Total Discount</strong>
          </td>
          <td class="amount-label">
            <span class="tax-amount">
              {{ totalDiscount | protectedCurrency:protected:' ' }}
            </span>
          </td>
        </tr>
        }

        <tr>
          <td>
            <strong class="tax-amount left-align">Taxable</strong>
          </td>
          <td class="amount-label">
            <span class="tax-amount">
              {{ taxable | protectedCurrency:protected:' ' }}
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <span class="tax-amount left-align">
              <strong>Tax</strong>
            </span>
          </td>
          <td class="amount-label">
            <span class="tax-amount">
              {{ taxAmount | protectedCurrency:protected:' ' }}
            </span>
          </td>
        </tr>
        @if (showTaxIncl && this.country ==='MY') {
        <tr>
          <td>
            <strong class="tax-amount left-align">Tax Inclusive</strong>
          </td>
          <td class="amount-label">
            <span class="tax-amount">{{
              taxInclusive | protectedCurrency:protected:' '
              }}</span>
          </td>
        </tr>
        }

        @if (showOutstanding) {
        <tr>
          <td>
            <strong class="tax-amount left-align">Total Payable</strong>
          </td>
          <td class="amount-label">
            <span class="tax-amount">{{
              outstandingAmount | protectedCurrency:protected: ' '
              }}</span>
          </td>
        </tr>
        }

        @if (country === 'PH' || country === 'MM') {
        <ng-container>
          @if (!hideTotal) {
          <tr class="border-bottom">
            <td>
              <span class="total-amount total-amount-title left-align">Total Amount</span>
            </td>
            <td class="amount-label">
              <span class="total-amount">
                {{ totalAmount | protectedCurrency:protected: currency }}
              </span>
            </td>
          </tr>
          }

          <tr>
            <td>
              <span class="tax-amount left-align">
                <strong>W/Tax</strong>
              </span>
            </td>
            <td class="amount-label">
              <span class="tax-amount">
                {{ wtaxAmount | protectedCurrency:protected: ' ' }}
              </span>
            </td>
          </tr>
          <tr *ngIf="showWVat">
            <td>
              <span class="tax-amount left-align">
                <strong>W/Vat</strong>
              </span>
            </td>
            <td class="amount-label">
              <span class="tax-amount">
                {{ wvatAmount | protectedCurrency:protected: ' ' }}
              </span>
            </td>
          </tr>
        </ng-container>
        }

        <ng-container>
          @if (hideTotal) {
          <tr>
            <td>
              <span class="total-amount total-amount-title left-align">
                Net Total
              </span>
            </td>
            <td class="amount-label" class="border-bottom-double">
              <span class="total-amount">
                {{ netTotalAmount | protectedCurrency:protected: currency }}
              </span>
            </td>
          </tr>
          } @else {
          <tr class="border-bottom-double">
            <td>
              <span class="total-amount total-amount-title left-align">
                Net Amount
              </span>
            </td>
            <td class="amount-label">
              <span class="total-amount">
                {{ netTotalAmount | protectedCurrency:protected: currency }}
              </span>
            </td>
          </tr>
          }
        </ng-container>
      </tbody>
    </table>
    }
  </div>
</div>

<!-- if screen width > 1700, 1 row have 2 columns -->
<div *ngIf="screenWidth > 1700" nz-row [nzJustify]="'space-evenly'">
  <div nz-col nzXs="24" [nzSm]="{ span: 8 }">
    <table>
      <tbody>
        @if (showTotalPaid) {
        <tr>
          <td>
            <span class="tax-amount left-align">
              <strong>Total Paid</strong>
            </span>
          </td>
          <td class="amount-label">
            <span class="tax-amount">{{
              getTotalPaid() | protectedCurrency:protected: ' '
              }}</span>
          </td>
        </tr>
        } @else if (eInvoiceSrv.isEnabled) {
        <tr>
          <td>
            <span class="tax-amount left-align">
              <strong>Amount Exempted from Tax</strong>
            </span>
          </td>
          <td class="amount-label">
            <span class="tax-amount">
              {{ amountExemptedFromTax | protectedCurrency:protected: ' ' }}
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <span class="tax-amount left-align">
              <strong>Exempted Tax Amount</strong>
            </span>
          </td>
          <td class="amount-label">
            <span class="tax-amount">
              {{ taxExemptionTotalAmount | protectedCurrency:protected:' ' }}
            </span>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>

  <div nz-col nzXs="24" [nzSm]="{ span: 5, offset: 2 }">
    @if (showDeposit) {
    <table>
      <tbody>
        <tr>
          <td>
            <span class="tax-amount left-align">
              <strong>Deposit Payment Amount</strong>
            </span>
          </td>
          <td class="amount-label">
            <div class="tax-amount deposit-box clickable-box" (click)="deposit.openListing()">
              {{ depositAmount | protectedCurrency:protected: ' '}}
            </div>
          </td>
        </tr>
        @if (depositInfo?.groupInfo?.fromReferenceCode) {
        <tr>
          <td class="right-align">Origin :</td>
          <td>
            <div style="margin-left: 10px">
              <nz-tag (click)="navigateToDepositPayment()" class="clickable-tag">
                {{ depositInfo?.groupInfo?.fromReferenceCode }}
              </nz-tag>
            </div>
          </td>
        </tr>
        }
      </tbody>
    </table>
    }
  </div>

  <div nz-col nzXs="24" [nzSm]="{ span: 8, offset: 1 }" class="right-align">
    @if (showTotalPaid) {
    <table>
      <tbody>
        <tr>
          <td>
            <span class="tax-amount left-align">
              <strong>O/T</strong>
            </span>
          </td>
          <td class="amount-label">
            <span class="tax-amount">
              {{ outstandingAmount | protectedCurrency:protected: ' ' }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
    }

    @if (!showTotalPaid) {
    <table>
      <tbody>
        <tr>
          <td>
            <strong class="tax-amount left-align">Subtotal</strong>
          </td>
          <td class="amount-label">
            <span class="tax-amount">{{ getSubtotal() | protectedCurrency:protected: ' ' }}</span>
          </td>
        </tr>

        @if (showDisc) {
        <tr>
          <td>
            <strong class="tax-amount left-align">Total Discount</strong>
          </td>
          <td class="amount-label">
            <span class="tax-amount">{{
              totalDiscount | protectedCurrency:protected: ' '
              }}</span>
          </td>
        </tr>
        }

        <tr>
          <td>
            <strong class="tax-amount left-align">Taxable</strong>
          </td>
          <td class="amount-label">
            <span class="tax-amount">{{ taxable | protectedCurrency:protected: ' ' }}</span>
          </td>
        </tr>
        <tr>
          <td>
            <span class="tax-amount left-align">
              <strong>Tax</strong>
            </span>
          </td>
          <td class="amount-label">
            <span class="tax-amount">{{ taxAmount | protectedCurrency:protected: ' ' }}</span>
          </td>
        </tr>
        @if (showTaxIncl && this.country ==='MY') {
        <tr>
          <td>
            <strong class="tax-amount left-align">Tax Inclusive</strong>
          </td>
          <td class="amount-label">
            <span class="tax-amount">{{
              taxInclusive | protectedCurrency:protected: ' '
              }}</span>
          </td>
        </tr>
        }

        @if (showOutstanding) {
        <tr>
          <td>
            <strong class="tax-amount left-align">Total Payable</strong>
          </td>
          <td class="amount-label">
            <span class="tax-amount">{{
              outstandingAmount | protectedCurrency:protected: ' '
              }}</span>
          </td>
        </tr>
        }

        @if (country === 'PH' || country === 'MM') {
        @if (!hideTotal) {
        <tr class="border-bottom">
          <td>
            <span class="total-amount total-amount-title left-align">Total Amount</span>
          </td>
          <td class="amount-label">
            <span class="total-amount">{{
              totalAmount | protectedCurrency:protected: currency
              }}</span>
          </td>
        </tr>
        }

        <tr>
          <td>
            <span class="tax-amount left-align">
              <strong>W/Tax</strong>
            </span>
          </td>
          <td class="amount-label">
            <span class="tax-amount">{{ wtaxAmount | protectedCurrency:protected: ' ' }}</span>
          </td>
        </tr>

        @if (showWVat) {
        <tr>
          <td>
            <span class="tax-amount left-align">
              <strong>W/Vat</strong>
            </span>
          </td>
          <td class="amount-label">
            <span class="tax-amount">{{
              wvatAmount | protectedCurrency:protected: ' '
              }}</span>
          </td>
        </tr>
        }
        }

        @if (hideTotal) {
        <tr *ngIf="roundingAdjustment !== 0 && roundingAdjustment !== null && roundingAdjustment !== undefined">
          <td>
            <span class="tax-amount left-align">
              <strong>Rounding</strong>
            </span>
          </td>
          <td class="amount-label">
            <span class="tax-amount">
              {{ roundingAdjustment < 0 ? '(' + (-roundingAdjustment | protectedCurrency:protected: ' ' ) + ')' :
                (roundingAdjustment | protectedCurrency:protected: ' ' ) }} </span>
          </td>
        </tr>
        <tr>
          <td>
            <span class="total-amount total-amount-title left-align">Net Total</span>
          </td>
          <td class="amount-label" class="border-bottom-double">
            <span class="total-amount">{{ netTotalAmount | protectedCurrency:protected: currency }}</span>
          </td>
        </tr>
        } @else {
        <tr class="border-bottom-double">
          <td>
            <span class="total-amount total-amount-title left-align">Net Amount</span>
          </td>
          <td class="amount-label">
            <span class="total-amount">{{
              netTotalAmount | protectedCurrency:protected: currency
              }}</span>
          </td>
        </tr>
        }
      </tbody>
    </table>
    }
  </div>
</div>

<app-deposit-entry #deposit [depositGroupId]="depositInfo?.groupInfo?.id"
  [editable]="depositInfo?.editable ?? false"></app-deposit-entry>